export enum MailFields {
    to = 'to',
    cc = 'cc',
    bcc = 'bcc',
    content = 'content',
    subject = 'subject',
    escalation = 'escalation',
    state = 'state',
}
